import ReactDOM from 'react-dom';
import React from 'react';
import ProductDetail from './ProductDetail';
import ProductCompare from './ProductCompare';
import ProductDetailCompare from './ProductDetailCompare';
import MmSearch from './MmSearch';
import MmDashboard from './dashboard/App';
// import { ConfigProvider } from './dashboard/contexts/ConfigContext';
import NiftyChart from './NiftyChart';
import './frontend.css';
import GoogleLoginComponent from './GoogleLoginComponent';
import EnquiryForm from './MmEnquary';

import MMCategoryBlock from './MMCategoryBlock';


function renderproductPartsComponents() {
  const blocks = document.querySelectorAll('section[id^="mm_product_part_block_"]');
  blocks.forEach(block => {
    const config = block.getAttribute('data-config');
    if (config) {
      const parsedConfig = JSON.parse(config);
      const container = block.querySelector('.react-product-part-block');
      if (container) {
        ReactDOM.render(<ProductDetail config={parsedConfig} />, container);
      } else {
        console.error('Container element not found');
      }
    } else {
      console.error('Configuration not found');
    }
  });
}

function rendermmSearchComponents() {
  const blocks = document.querySelectorAll('section[id^="mm_mmsearch_block_"]');
  blocks.forEach(block => {
    const config = block.getAttribute('data-config');
    console.log("rendermmSearchComponents config", config);
    if (config) {
      const parsedConfig = JSON.parse(config);
      const container = block.querySelector('.react-mmsearch-block');
      if (container) {
        ReactDOM.render(<MmSearch config={parsedConfig} />, container);
      } else {
        console.error('Container mmsearch element not found');
      }
    } else {
      console.error('Configuration mmsearch not found');
    }
  });
}

function renderproductOwnerssComponents() {
  const blocks = document.querySelectorAll('section[id^="mm_product_owner_block_"]');
  blocks.forEach(block => {
    const config = block.getAttribute('data-config');
    if (config) {
      const parsedConfig = JSON.parse(config);
      const container = block.querySelector('.react-product-owner-block');
      if (container) {
        ReactDOM.render(<ProductOwner config={parsedConfig} />, container);
      } else {
        console.error('Container element not found');
      }
    } else {
      console.error('Configuration not found');
    }
  });
}

function renderMmDashboardComponents() {
  const blocks = document.querySelectorAll('section[id^="mm_dashboard_block_"]');
  blocks.forEach(block => {
    const config = block.getAttribute('data-config');
    console.log("renderMmDashboardComponents config", config);
    if (config) {
      const parsedConfig = JSON.parse(config);
      const container = block.querySelector('.react-mmdashboard-block');
      if (container) {
        ReactDOM.render(<MmDashboard config={parsedConfig} />, container);
      } else {
        console.error('Container mmdashboard element not found');
      }
    } else {
      console.error('Configuration mmdashboard not found');
    }
  });
}

function renderproductCompareComponents() {
  const blocks = document.querySelectorAll('section[id^="mm_product_compare_block_"]');
  blocks.forEach(block => {
    const config = block.getAttribute('data-config');
    if (config) {
      const parsedConfig = JSON.parse(config);
      const container = block.querySelector('.react-product-compare-block');
      if (container) {
        ReactDOM.render(<ProductCompare config={parsedConfig} />, container);
      } else {
        console.error('Container element not found');
      }
    } else {
      console.error('Configuration not found');
    }
  });
}

function renderProductDetailCompareComponents() {
  const blocks = document.querySelectorAll('section[id^="mm_product_detail_compare_block_"]');
  blocks.forEach(block => {
    const config = block.getAttribute('data-config');
    if (config) {
      const parsedConfig = JSON.parse(config);
      const container = block.querySelector('.react-product-detail-compare-block');
      if (container) {
        ReactDOM.render(<ProductDetailCompare config={parsedConfig} />, container);
      } else {
        console.error('Container element not found');
      }
    } else {
      console.error('Configuration not found');
    }
  });
}


function renderNiftyChart() {
  const blocks = document.querySelectorAll('section[id^="mm_nifty_chart_block_"]');
  blocks.forEach(block => {
    const config = block.getAttribute('data-config');
    if (config) {
      const parsedConfig = JSON.parse(config);
      const container = block.querySelector('.react-nifty-chart-block');
      if (container) {
        ReactDOM.render(<NiftyChart config={parsedConfig} />, container);
      } else {
        console.error('Container element not found');
      }
    } else {
      console.error('Configuration not found');
    }
  });
}

function renderGoogleLoginBtn() {
  const blocks = document.querySelectorAll('section[id^="mm_gogle_login_btn_"]');
  blocks.forEach(block => {
    const config = block.getAttribute('data-config');
    if (config) {
      const parsedConfig = JSON.parse(config);
      const container = block.querySelector('.mm_gogle_login_btn_1');
      if (container) {
        ReactDOM.render(<GoogleLoginComponent config={parsedConfig}/>, container);
      } else {
        console.error('Container element not found');
      }
    } else {
      console.error('Configuration not found');
    }
  });
}


function renderEnquiryComponents() {
  const blocks = document.querySelectorAll('section[id^="mm_enquiry_form_block_"]');
  blocks.forEach(block => {
    const config = block.getAttribute('data-config');
    if (config) {
      const parsedConfig = JSON.parse(config);
      const container = block.querySelector('.react-enquiry-form-block');
      if (container) {
        ReactDOM.render(
          <EnquiryForm
            config={parsedConfig}
            apiUrl={parsedConfig.PY_API_URL + 'enquiry'}
          />,
          container
        );
      } else {
        console.error('Container element not found');
      }
    } else {
      console.error('Configuration not found');
    }
  });
}

function renderMMCategoryBlockComponents() {
  const blocks = document.querySelectorAll('section[id^="mm_cat_block_"]');
  blocks.forEach(block => {
    const config = block.getAttribute('data-config');
    if (config) {
      const parsedConfig = JSON.parse(config);
      const container = block.querySelector('.react-category-block');
      if (container) {
        ReactDOM.render(<MMCategoryBlock config={parsedConfig} />, container);
      } else {
        console.error('Container element not found');
      } 
    } else {
      console.error('Configuration not found');
    }
  });
}


document.addEventListener('DOMContentLoaded', () => {
  renderproductPartsComponents();
  rendermmSearchComponents();
  // renderproductOwnerssComponents();
  renderMmDashboardComponents();
  renderproductCompareComponents();
  renderProductDetailCompareComponents();
  renderNiftyChart();
  renderGoogleLoginBtn();
  renderEnquiryComponents();
  renderMMCategoryBlockComponents();
});


jQuery(window).scroll(function(){
  if (jQuery(window).scrollTop() >= 300) {
    jQuery('.product-page-header').addClass('fixed-product-header');
  } else {
    jQuery('.product-page-header').removeClass('fixed-product-header');
  }
});